import React from 'react'

const NiDownload = () => {
  return (
    <svg width="18" height="18" class="mb-4 text-text-primary" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.14355 13C2.95215 14.4616 2.95215 14.9479 3.14355 16.4096C3.51203 19.2234 5.5789 21.4088 8.16847 21.7227L8.92127 21.814C10.9675 22.062 13.0325 22.062 15.0787 21.814L15.8315 21.7227C18.4211 21.4088 20.488 19.2234 20.8564 16.4096C21.0479 14.9479 21.0479 14.4616 20.8564 13" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round"></path><path opacity="0.6" d="M9.17187 13.1716L11.2932 15.2929C11.6837 15.6834 12.3168 15.6834 12.7074 15.2929L14.8287 13.1716M12.0002 2L12.0003 15.2929" stroke="currentColor" strokeWidth="1.5" stroke-linecap="round"></path></svg>
  )
}

export default NiDownload
